<template>
    <div>
        <loading
            :active.sync="loading.content"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <a
                    @click="$router.go(-1)"
                    class="headerButton"
                    style="cursor: pointer"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">
                {{ title != undefined ? title : 'Kirim Uang' }}
            </div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule">
            <!-- Opsi Metode Transfer -->
            <div class="section mt-2">
                <div class="transactions">
                    <!-- item -->
                    <a
                        href="javascript:;"
                        class="item"
                        style="padding: 10px"
                        @click="modalTransferMethod('show')"
                    >
                        <div class="detail">
                            <div style="color: #17273e">
                                <header
                                    style="
                                        font-size: 12px;
                                        color: #726d79;
                                        margin-bottom: 2px;
                                    "
                                >
                                    Metode Transfer
                                </header>
                                <b
                                    style="
                                        font-size: 16px;
                                        margin-top: 5px;
                                        margin-bottom: 5px;
                                    "
                                    v-html="trasferMethodSelected.name"
                                ></b>
                                <footer
                                    style="
                                        font-size: 12px;
                                        line-height: 1.3;
                                        color: #726d79;
                                        margin-top: 2px;
                                    "
                                    v-html="trasferMethodSelected.description"
                                ></footer>
                            </div>
                        </div>

                        <div class="right">
                            <div class="icon">
                                <ion-icon name="chevron-down"></ion-icon>
                            </div>
                        </div>
                    </a>
                    <!-- * item -->
                </div>
            </div>

            <!-- Opsi bank -->
            <div class="section mt-2">
                <div class="transactions">
                    <!-- item -->
                    <a
                        href="javascript:;"
                        class="item"
                        :class="
                            data.transfer_method == '' ||
                            loading.product ||
                            product == 0
                                ? 'disabled'
                                : ''
                        "
                        style="padding: 10px"
                        @click="modalProduct('show')"
                    >
                        <div class="detail">
                            <img
                                v-lazyload
                                :src="require('@/assets/Loader-2.png')"
                                :data-src="
                                    require('@/assets/icon_menu/icon_transfer_bank.png')
                                "
                                alt="image"
                                class="image-block imaged"
                                style="width: 30px"
                            />
                            <div style="color: #17273e">
                                <b
                                    style="
                                        font-size: 16px;
                                        margin-top: 5px;
                                        margin-bottom: 5px;
                                    "
                                    >{{ data.product_name }}</b
                                >
                                <footer
                                    style="
                                        font-size: 12px;
                                        line-height: 1.3;
                                        color: #726d79;
                                        margin-top: 2px;
                                    "
                                >
                                    {{
                                        data.product_description != ''
                                            ? data.product_description
                                            : trasferMethodSelected.description_option_service
                                    }}
                                </footer>
                            </div>
                        </div>

                        <div class="right">
                            <button
                                class="btn btn-primary pl-3 pr-3"
                                @click="modalProduct('show')"
                                :disabled="data.transfer_method == ''"
                            >
                                <span
                                    v-if="
                                        data.transfer_method != '' &&
                                        loading.product == false
                                    "
                                    >Pilih</span
                                >
                                <span
                                    class="spinner-border spinner-border-sm mr-1 ml-1"
                                    role="status"
                                    aria-hidden="true"
                                    v-else
                                ></span>
                            </button>
                        </div>
                    </a>
                    <!-- * item -->
                </div>

                <!-- <ul class="listview image-listview inset">
          <li>
            <div class="item" style="padding: 8px 12px;">
              <img
                v-lazyload
                :src="require('@/assets/Loader-2.png')"
                :data-src="require('@/assets/bank.png')"
                alt="logo_bank"
                class="image mr-1"
              />
              <div class="in">
                <div>
                  <b style="font-size:15px;font-weight: bold;">{{
                    data.product_name
                  }}</b>
                  <footer>Transfer Bank</footer>
                </div>
                <span class="text-muted">
                  <button
                    class="btn btn-primary pl-3 pr-3 "
                    @click="modalProduct('show')"
                    :disabled="data.transfer_method == ''"
                  >
                    Pilih
                  </button>
                </span>
              </div>
            </div>
          </li>
        </ul> -->
            </div>

            <div class="section inset mt-2">
                <div class="form-group boxed p-0 mb-2">
                    <div class="input-wrapper">
                        <label class="label">Nomor Rekening</label>
                        <input
                            type="tel"
                            class="form-control form-control-lg"
                            v-model="data.no_rekening"
                        />

                        <a
                            href="Javascript:;"
                            class="custom-icon-inside"
                            @click="openPhoneBook()"
                        >
                            <img
                                :src="require('@/assets/icon_contactbook.png')"
                                alt="image"
                                class="image w-75"
                            />
                        </a>
                    </div>
                </div>

                <div class="pt-2 pb-2">
                    <div class="form-group input-nominal p-2">
                        <label class="label" style="font-weight: bold"
                            >Nominal</label
                        >
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">Rp</span>
                            </div>
                            <input
                                type="tel"
                                class="form-control form-control-lg"
                                v-model="data.nominal"
                                oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                                @input="inputNominal()"
                            />
                        </div>
                    </div>

                    <div
                        class="form-group basic mt-1 pb-0"
                        style="white-space: nowrap; overflow: auto"
                    >
                        <button
                            v-for="item in nominal"
                            :key="item"
                            class="btn btn-outline-primary btn-sm mr-1 mb-1"
                            style="border-radius: 50px; border: 1px solid"
                            @click="inputNominal(item)"
                        >
                            <ion-icon name="add-circle"></ion-icon> Rp
                            {{ item | rupiah }}
                        </button>
                    </div>
                    <div class="form-group mt-0 mb-1">
                        <div
                            class="row"
                            style="font-size: 13px; line-height: 25px"
                        >
                            <div class="col-6">
                                <label class="mb-0"
                                    >Biaya Layanan
                                    {{ VUE_ENV.VUE_APP_NAME }}</label
                                >
                            </div>
                            <div class="col-6 text-right">
                                <label
                                    class="mb-0"
                                    style="font-weight: bold"
                                    v-if="data.fee_admin != ''"
                                    >Rp {{ data.fee_admin | rupiah }}</label
                                >
                                <label class="mb-0" v-else
                                    ><ion-icon
                                        name="ellipsis-horizontal"
                                    ></ion-icon
                                ></label>
                            </div>
                        </div>

                        <div
                            class="row"
                            style="font-size: 13px; line-height: 25px"
                        >
                            <div class="col-6">
                                <label class="mb-0">Biaya ke Pelanggan</label>
                            </div>
                            <div class="col-6 text-right">
                                <a
                                    href="Javascript:;"
                                    class="mb-0 text-primary"
                                    style="
                                        font-weight: bold;
                                        text-decoration: underline;
                                    "
                                    v-if="data.fee_customer != ''"
                                    @click="dialogUpdateFeeCustomer('show')"
                                    >Rp {{ data.fee_customer | rupiah }}
                                    <i
                                        class="icon ion-md-create"
                                        style="margin-left: 2px"
                                    ></i>
                                </a>
                                <label class="mb-0" v-else
                                    ><ion-icon
                                        name="ellipsis-horizontal"
                                    ></ion-icon
                                ></label>
                            </div>
                        </div>
                    </div>
                    <div class="form-group basic">
                        <ButtonLoader
                            :loading="loading.button_validate"
                            :styled="'btn btn-primary btn-block btn-lg'"
                            @click.native="validate_account_number()"
                            :disabled="
                                data.product_id == '' ||
                                data.no_rekening == '' ||
                                data.nominal == ''
                            "
                            >Periksa</ButtonLoader
                        >
                    </div>
                    <div class="text-center">
                        <router-link
                            :to="{ name: 'sendmoney.tos' }"
                            style="font-size: 12px"
                        >
                            Syarat & Ketentuan Layanan
                        </router-link>
                    </div>
                </div>
            </div>
            <!-- * Form -->
        </div>
        <div class="section text-center">
            <p style="font-size: 13px">
                Powered By<br />
                <img
                    v-lazyload
                    :src="require('@/assets/Loader-2.png')"
                    :data-src="require('@/assets/flip_logo.png')"
                    alt="logo_flip"
                    class="image"
                    width="30px"
                /><span class="mr-1 ml-1"> </span
                ><img
                    v-lazyload
                    :src="require('@/assets/Loader-2.png')"
                    :data-src="require('@/assets/brick_logo.png')"
                    alt="logo_flip"
                    class="image"
                    height="30px"
                />
            </p>
        </div>

        <!-- Modal Opsi Metode Transfer -->
        <action-sheet
            ref="option_transfer_method"
            :title="'Pilih Metode Transfer'"
            :inset="false"
            :content-full="true"
            :contentHeight="false"
        >
            <ul class="listview image-listview">
                <li v-for="item in transfer_method" :key="item.code">
                    <a
                        style="cursor: pointer"
                        class="item"
                        @click="selectTransferMethod(item.code)"
                    >
                        <div class="in">
                            <div>
                                <b v-html="item.name"></b>
                                <footer v-html="item.description"></footer>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
        </action-sheet>

        <!-- Modal Produk Bank -->
        <action-sheet
            ref="product"
            :title="'Pilih Layanan'"
            :inset="false"
            :content-full="true"
            :contentHeight="false"
        >
            <div class="form-group boxed pl-1 pr-1">
                <input
                    type="text"
                    class="form-control"
                    placeholder="Cari Bank"
                    style="font-size: 13px"
                    v-model="keywords"
                />
            </div>
            <ul class="listview image-listview">
                <li v-for="item in filterProduct(product)" :key="item.id">
                    <a
                        style="cursor: pointer"
                        class="item"
                        @click="selectProduct(item)"
                    >
                        <img
                            v-lazyload
                            :src="require('@/assets/Loader-2.png')"
                            :data-src="require('@/assets/bank.png')"
                            alt="logo_bank"
                            class="image"
                        />
                        <!-- <img :src="require('@/assets/bank.png')" alt="image" class="image"> -->
                        <div class="in">
                            <div>
                                <b>{{ item.product_name }}</b>
                                <footer>
                                    Biaya Layanan Rp
                                    {{ item.fee_admin | rupiah }}
                                </footer>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
        </action-sheet>

        <!-- Modal Confirmation -->
        <action-sheet
            ref="modalConfirmation"
            :title="'Konfirmasi Pengiriman'"
            :header="true"
            :inset="false"
            :content-height="true"
        >
            <div style="border-bottom: 1px dashed #dee2e6">
                <p style="font-size: 12px; line-height: 15px">
                    Pastikan data pengiriman uang yang tertera sudah benar,
                    karena kami tidak bertanggung jawab jika terdapat kesalahan
                    pada data dibawah ini.
                </p>
            </div>
            <div
                class="mb-1 mt-1 pb-1"
                style="border-bottom: 1px dashed #dee2e6"
            >
                <table
                    class="w-100"
                    style="font-size: 13px; line-height: 1.5rem"
                >
                    <tr>
                        <td>Bank</td>
                        <td style="text-align: right">
                            {{ data.product_name }}
                        </td>
                    </tr>
                    <tr>
                        <td>No. Rekening</td>
                        <td style="text-align: right">
                            {{ data.no_rekening }}
                        </td>
                    </tr>
                    <tr>
                        <td>Nama Pemilik</td>
                        <td style="text-align: right">
                            <b>{{ data.account_holder }}</b>
                        </td>
                    </tr>
                    <tr>
                        <td>Nominal</td>
                        <td style="text-align: right">Rp {{ data.nominal }}</td>
                    </tr>
                </table>
            </div>
            <div
                class="mb-1 mt-1 pb-1"
                style="border-bottom: 1px dashed #dee2e6"
            >
                <table
                    class="w-100"
                    style="font-size: 12px; line-height: 1.5rem"
                >
                    <tr>
                        <td>Biaya Layanan {{ VUE_ENV.VUE_APP_NAME }}</td>
                        <td style="text-align: right">
                            Rp {{ data.fee_admin | rupiah }}
                        </td>
                    </tr>
                    <tr>
                        <td>Total Bayar ke {{ VUE_ENV.VUE_APP_NAME }}</td>
                        <td style="text-align: right; font-weight: bold">
                            Rp
                            {{
                                (parseInt(data.nominal.replace(/[^,\d]/g, '')) +
                                    parseInt(data.fee_admin))
                                    | rupiah
                            }}
                        </td>
                    </tr>
                    <tr>
                        <td>Cashback</td>
                        <td style="text-align: right">
                            Rp {{ data.cashback | rupiah }}
                        </td>
                    </tr>
                    <tr>
                        <td>Points</td>
                        <td class="text-warning" style="text-align: right">
                            +{{ data.points | rupiah }} points
                        </td>
                    </tr>
                </table>
            </div>
            <div
                class="mb-1 mt-1 pb-1"
                style="border-bottom: 1px dashed #dee2e6"
            >
                <table
                    class="w-100"
                    style="font-size: 12px; line-height: 1.5rem"
                >
                    <tr>
                        <td>Biaya ke Pelanggan</td>
                        <td style="text-align: right; font-weight: bold">
                            Rp {{ data.fee_customer | rupiah }}
                        </td>
                    </tr>
                </table>

                <div
                    class="alert alert-grey-custom mt-1 mb-1 pt-2 pb-2"
                    role="alert"
                    style="background: rgba(237, 237, 241, 0.5)"
                >
                    <div
                        class="alert-custom-container pb-1"
                        style="border-bottom: 1px dashed #c5c9ce"
                    >
                        <div class="alert-custom-description">
                            <b>Total Bayar Pelanggan</b>
                        </div>
                        <span
                            style="
                                font-size: 16px;
                                color: #17273e;
                                font-weight: 700;
                            "
                        >
                            Rp
                            {{
                                (parseInt(data.nominal.replace(/[^,\d]/g, '')) +
                                    data.fee_customer)
                                    | rupiah
                            }}
                        </span>
                    </div>
                    <div class="mt-1">
                        <small
                            ><i
                                >*) Potensi Keuntungan dari Penjualan ke
                                Pelanggan sebesar
                                <b class="text-success"
                                    >Rp {{ potensiKeuntungan | rupiah }}</b
                                ></i
                            ></small
                        >
                    </div>
                </div>
            </div>
            <div
                class="alert mt-1 mb-1 pt-2 pb-2"
                role="alert"
                style="
                    line-height: 1rem;
                    color: #dc3545;
                    background-color: #f8d7da;
                    border-color: #f5c6cb;
                "
                v-if="
                    customer.balance <
                    parseInt(data.nominal.replace(/[^,\d]/g, '')) +
                        parseInt(data.fee_admin)
                "
            >
                <div
                    style="
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        width: 100%;
                    "
                >
                    <div>
                        <span style="font-size: 13px"
                            ><b
                                >Saldo kurang! Sisa Rp
                                {{ customer.balance | rupiah }}</b
                            ></span
                        >
                    </div>
                    <span class="text-muted">
                        <button
                            class="btn btn-warning btn-sm rounded shadowed pl-3 pr-3"
                            style="font-size: 12px; height: 30px"
                            @click="redirectDepositPage()"
                        >
                            Isi Saldo
                        </button>
                    </span>
                </div>
            </div>
            <div class="form-group basic pb-0">
                <div class="row">
                    <div class="col-6">
                        <button
                            class="btn btn-outline-primary btn-block btn-lg"
                            style="
                                height: 40px;
                                border-width: 1px;
                                font-size: 12px;
                            "
                            @click="hideConfirm()"
                        >
                            Batal
                        </button>
                    </div>
                    <div class="col-6">
                        <ButtonLoader
                            :loading="loading.button_submit"
                            :styled="'btn btn-primary btn-block btn-lg'"
                            style="height: 40px; font-size: 12px"
                            @click.native="verifyWithOutPin()"
                            :disabled="
                                customer.balance <
                                parseInt(data.nominal.replace(/[^,\d]/g, '')) +
                                    parseInt(data.fee_admin)
                            "
                            v-if="customer.pin_trx == 'DISABLED'"
                            >Kirim</ButtonLoader
                        >
                        <ButtonLoader
                            :loading="loading.button_submit"
                            :styled="'btn btn-primary btn-block btn-lg'"
                            style="height: 40px; font-size: 12px"
                            @click.native="verifyWithPin()"
                            :disabled="
                                customer.balance <
                                parseInt(data.nominal.replace(/[^,\d]/g, '')) +
                                    parseInt(data.fee_admin)
                            "
                            v-else
                            >Kirim</ButtonLoader
                        >
                    </div>
                </div>
            </div>
        </action-sheet>

        <!-- Modal Status Pembelian -->
        <action-sheet ref="status" :title="'Status Pembelian'" :inset="true">
            <div class="iconbox text-success">
                <ion-icon name="checkmark-circle"></ion-icon>
            </div>
            <div class="text-center p-2">
                <h3>Pembayaran Berhasil</h3>
                <p>Transaksi Anda sedang diproses</p>
            </div>
            <div class="form-group basic">
                <button
                    class="btn btn-primary btn-block btn-lg"
                    @click="directToHistory()"
                >
                    Lihat Riwayat Transaksi
                </button>
                <button
                    class="btn btn-outline-primary btn-block btn-lg"
                    @click="hideStatus"
                >
                    Kembali
                </button>
            </div>
        </action-sheet>

        <!-- Dialog update fee customer -->
        <Dialog
            ref="dialog_update_fee_customer"
            :loading="false"
            :title="'Ubah Biaya ke Pelanggan'"
            @confirm="updateFeeCustomer()"
        >
            <div class="form-group input-nominal p-2">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">Rp</span>
                    </div>
                    <input
                        type="tel"
                        class="form-control form-control-lg"
                        v-model="fee_customer_reference"
                        oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                        @input="inputFeeCustomer()"
                    />
                </div>
            </div>

            <div
                class="form-group basic mt-1 pb-0"
                style="white-space: nowrap; overflow: auto"
            >
                <button
                    v-for="item in nominal_fee_customer"
                    :key="item"
                    class="btn btn-outline-primary btn-sm mr-1"
                    style="border-radius: 50px; border: 1px solid"
                    @click="inputFeeCustomer(item)"
                >
                    <ion-icon name="add-circle"></ion-icon> Rp
                    {{ item | rupiah }}
                </button>
            </div>
        </Dialog>

        <!-- Dialog update apk -->
        <Dialog
            ref="dialog_update_apk"
            :loading="false"
            :title="'Update Aplikasi'"
            @confirm="updateApk()"
        >
            Aplikasi versi terbaru telah tersedia di playstore. Update Sekarang!
        </Dialog>
    </div>
</template>
<script>
    import $axios from './../../../api.js';
    import { mapState } from 'vuex';
    export default {
        props: ['toast_reference', 'transfer_method_selected', 'title'],
        data() {
            return {
                loading: {
                    button_submit: false,
                    button_validate: false,
                    content: true,
                    modal: false,
                    product: false,
                },
                product: [],
                transfer_method: [
                    {
                        code: 'TRANSFER_ONLINE',
                        name: 'Transfer Online',
                        description:
                            'Metode Transfer Online antar bank secara realtime,<br>biaya admin mulai Rp 2.000an',
                        description_option_service: 'Transfer Bank',
                    },
                    {
                        code: 'BI_FAST',
                        name: 'Transfer BI-FAST',
                        description:
                            'Metode Transfer Online antar bank peserta BI-FAST,<br>biaya admin mulai Rp 1.000an',
                        description_option_service: 'Transfer Bank',
                    },
                    {
                        code: 'TRANSFER_VA',
                        name: 'Transfer VA <label class="badge badge-success pl-2 pr-2 mb-0">Baru</label>',
                        description:
                            'Metode Transfer ke Rekening Virtual Account,<br>biaya admin mulai Rp 2.000an',
                        description_option_service: 'Transfer VA',
                    },
                    {
                        code: 'EWALLET',
                        name: 'Top Up E-Wallet <label class="badge badge-success pl-2 pr-2 mb-0">Baru</label>',
                        description:
                            'Metode Top Up Saldo E-Wallet bebas nominal,<br>biaya admin mulai Rp 500an',
                        description_option_service: 'Top Up E-Wallet',
                    },
                ],
                product_data: {
                    product_id: '',
                    product_name: 'Pilih Layanan',
                    product_description: '',
                    fee_admin: '',
                    fee_customer: '',
                    cashback: '',
                    points: '0',
                },
                product_select: {},
                data: {
                    transfer_method: 'TRANSFER_ONLINE',
                    product_id: '',
                    product_name: '',
                    product_description: '',
                    no_rekening: '',
                    account_holder: '',
                    fee_admin: '',
                    fee_customer: '',
                    cashback: '',
                    points: '0',
                    nominal: '',
                    total: '',
                    pin: '',
                },
                fee_customer_reference: '0',
                nominal: [10000, 50000, 100000, 500000, 1000000, 2000000],
                nominal_fee_customer: [5000, 8000, 10000],
                keywords: '',
                time: null,
            };
        },
        created() {
            if (this.transfer_method_selected != null) {
                this.data.transfer_method = this.transfer_method_selected;
            }
            this.getProduct();
            this.selectProduct(this.product_data);

            // window.fbq('track', 'ViewContent');
        },
        computed: {
            ...mapState(['customer', 'toast', 'VUE_ENV', 'device']),
            trasferMethodSelected() {
                return this.transfer_method.find(
                    method => method.code === this.data.transfer_method
                );
            },
            potensiKeuntungan() {
                let nominal = parseInt(
                    this.data.nominal.replace(/[^,\d]/g, '')
                );
                let fee_customer = parseInt(this.data.fee_customer);
                let fee_admin = parseInt(this.data.fee_admin);
                let price = nominal + fee_admin;
                let price_customer = nominal + fee_customer;
                return price_customer - price;
            },
        },
        methods: {
            updateApk() {
                this.dialogUpdateAPK('hide');
                window.open(
                    'https://play.google.com/store/apps/details?id=com.digifazz.app',
                    '_blank'
                );
            },
            directToHistory() {
                this.hideStatus();
                this.$router.push({
                    name: 'transaction.index',
                });
            },
            dialogUpdateAPK(value) {
                let element = this.$refs.dialog_update_apk.$el;
                window.$(element).modal(value);
            },
            inAppReview() {
                if (typeof window.AndroidNative !== 'undefined') {
                    window.AndroidNative.inAppReview();
                }
            },
            filterProduct: function (product) {
                var app = this;
                return product.filter(function (item) {
                    let regex = new RegExp('(' + app.keywords + ')', 'i');
                    return item.product_name.match(regex);
                });
            },
            dialogUpdateFeeCustomer(value) {
                let element = this.$refs.dialog_update_fee_customer.$el;
                window.$(element).modal(value);
            },
            updateFeeCustomer() {
                this.dialogUpdateFeeCustomer('hide');
                this.data.fee_customer = parseInt(
                    this.fee_customer_reference.replace(/[^,\d]/g, '')
                );
            },
            modalProduct(value) {
                if (this.$refs.product != undefined) {
                    let element = this.$refs.product.$el;
                    window.$(element).modal(value);
                }
            },
            selectProduct(data) {
                this.data.product_id = data.product_id;
                this.data.product_name = data.product_name;
                this.data.product_description =
                    data.product_description != null
                        ? data.product_description
                        : '';
                this.data.fee_admin = data.fee_admin;
                this.data.fee_customer = data.fee_admin;
                this.data.cashback = data.cashback;
                this.data.points = data.points;
                this.fee_customer_reference = '0';
                this.modalProduct('hide');
            },
            showConfirm() {
                this.data.pin = '';
                this.$store.commit('RESET_TOAST');

                let element = this.$refs.modalConfirmation.$el;
                window.$(element).modal('show');
            },
            hideConfirm() {
                this.data.pin = '';
                let element = this.$refs.modalConfirmation.$el;
                window.$(element).modal('hide');
            },
            showStatus() {
                let element = this.$refs.status.$el;
                window.$(element).modal('show');
            },
            hideStatus() {
                let element = this.$refs.status.$el;
                window.$(element).modal('hide');
                this.inAppReview();
            },
            getProduct() {
                this.loading.product = true;
                $axios
                    .post('/sendmoney/product', {
                        transfer_method: this.data.transfer_method,
                    })
                    .then(response => {
                        this.loading.product = false;
                        if (response.data.data.length > 0) {
                            this.product = response.data.data;
                            this.loading.content = false;
                        } else {
                            this.product = [];
                            this.$store.commit('SET_TOAST', {
                                show: true,
                                message: 'Produk belum tersedia',
                                tipe: 'default',
                                icon: 'warning',
                            });
                            this.loading.content = false;
                        }
                    })
                    .catch(e => {
                        this.loading.product = false;
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: e.response.data.message,
                            tipe: 'default',
                            icon: 'danger',
                        });
                        this.loading.content = false;
                    });
            },
            validate_account_number() {
                this.$store.commit('RESET_TOAST');
                if (
                    this.data.no_rekening != '' &&
                    this.data.nominal != '' &&
                    this.data.product_id != ''
                ) {
                    this.loading.button_validate = true;
                    $axios
                        .post('/sendmoney/validate', this.data)
                        .then(response => {
                            this.data.account_holder =
                                response.data.data.account_holder;
                            this.data.fee_admin = response.data.data.fee_admin;
                            this.data.cashback = response.data.data.cashback;
                            this.loading.button_validate = false;
                            this.showConfirm();
                        })
                        .catch(e => {
                            this.loading.button_validate = false;
                            if (
                                e.response.status == 400 &&
                                e.response.data.responseCode ==
                                    'AVAILABLE_UPDATE'
                            ) {
                                this.dialogUpdateAPK('show');
                            } else {
                                this.$store.commit('SET_TOAST', {
                                    show: true,
                                    message: e.response.data.message,
                                    tipe: 'default',
                                    icon: 'danger',
                                });
                            }
                        });
                } else {
                    this.$store.commit('SET_TOAST', {
                        show: true,
                        message: 'Pastikan semua kolom data telah diisi',
                        tipe: 'default',
                        icon: 'danger',
                    });
                }
            },
            verifyWithOutPin() {
                this.button_submit = true;
                $axios
                    .post('/sendmoney/send', this.data)
                    .then(() => {
                        this.button_submit = false;
                        this.data.product_id = '';
                        this.data.product_name = '';
                        this.data.no_rekening = '';
                        this.data.account_holder = '';
                        this.data.fee_admin = '';
                        this.data.cashback = '';
                        this.data.nominal = '';
                        this.data.total = '';

                        this.product_data = {
                            product_id: '',
                            product_name: '- Pilih Bank -',
                            fee_admin: '',
                            fee_customer: '',
                            cashback: '',
                            points: '0',
                        };
                        this.fee_customer_reference = '0';
                        this.selectProduct(this.product_data);
                        this.hideConfirm();
                        this.showStatus();
                    })
                    .catch(e => {
                        this.hideConfirm();
                        this.button_submit = false;
                        if (
                            e.response.status == 400 &&
                            e.response.data.responseCode == 'AVAILABLE_UPDATE'
                        ) {
                            this.dialogUpdateAPK('show');
                        } else {
                            this.$store.commit('SET_TOAST', {
                                show: true,
                                message: e.response.data.message,
                                tipe: 'default',
                                icon: 'danger',
                            });
                        }
                    });
            },
            verifyWithPin() {
                this.hideConfirm();
                this.$router.push({
                    name: 'auth.pin.verify',
                    params: {
                        data_reference: this.data,
                        url_reference: '/sendmoney/send',
                        previous_page_reference: 'sendmoney.order',
                        params_previous_page_reference: {
                            transfer_method_selected:
                                this.transfer_method_selected,
                        },
                        next_page_reference: 'sendmoney.order',
                        params_next_page_reference: {
                            transfer_method_selected:
                                this.transfer_method_selected,
                        },
                    },
                });
            },
            openPhoneBook() {
                if (typeof window.AndroidNative !== 'undefined') {
                    window.AndroidNative.openPhoneBook();
                }
            },
            redirectDepositPage() {
                this.hideConfirm();
                this.$router.push({ name: 'deposit' });
            },
            inputNominal(nominal) {
                this.$store.commit('RESET_TOAST');
                if (this.data.nominal == '') {
                    this.data.nominal = '0';
                }
                if (nominal == undefined) {
                    const nominal_request = parseInt(this.data.nominal);
                    this.data.nominal = this.$options.filters.inputRupiah(
                        nominal_request.toString()
                    );
                } else {
                    const nominal_request =
                        parseInt(this.data.nominal.replace(/[^,\d]/g, '')) +
                        nominal;
                    this.data.nominal = this.$options.filters.inputRupiah(
                        nominal_request.toString()
                    );
                }
            },
            inputFeeCustomer(nominal) {
                this.$store.commit('RESET_TOAST');
                if (this.fee_customer_reference == '') {
                    this.fee_customer_reference = '0';
                }
                if (nominal == undefined) {
                    const nominal_request = parseInt(
                        this.fee_customer_reference
                    );
                    this.fee_customer_reference =
                        this.$options.filters.inputRupiah(
                            nominal_request.toString()
                        );
                } else {
                    const nominal_request =
                        parseInt(
                            this.fee_customer_reference.replace(/[^,\d]/g, '')
                        ) + nominal;
                    this.fee_customer_reference =
                        this.$options.filters.inputRupiah(
                            nominal_request.toString()
                        );
                }
            },
            phone(phone) {
                this.data.no_rekening = phone.replace(/\D/g, '');
            },
            modalTransferMethod(value) {
                let element = this.$refs.option_transfer_method.$el;
                window.$(element).modal(value);
            },
            selectTransferMethod(value) {
                this.selectProduct(this.product_data);
                this.data.transfer_method = value;
                this.modalTransferMethod('hide');
                this.getProduct();
            },
        },
        mounted() {
            setTimeout(() => {
                if (this.toast_reference != undefined) {
                    if (
                        this.toast_reference.show &&
                        this.toast_reference.icon == 'success'
                    ) {
                        this.showStatus();
                    } else {
                        this.$store.commit('SET_TOAST', this.toast_reference);
                    }
                }
            }, 500);
            window['phone'] = phone => {
                this.phone(phone);
            };
        },
        destroyed() {
            this.$store.commit('RESET_TOAST');
        },
        filters: {
            inputRupiah: function (value) {
                value = value.toString();
                var number_string = value.replace(/[^,\d]/g, '').toString(),
                    split = number_string.split(','),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);

                if (ribuan) {
                    var separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }

                rupiah =
                    split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                return rupiah;
            },
        },
    };
</script>
